<template lang="html">
  <svg class="emotion" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g v-if="emotion === 'angry'">
      <path d="M8 16L10 14L12 16" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 5L8 10" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="5" cy="9" r="1" fill="#FF7E7E"/>
      <path d="M17 5L12 10" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle r="1" transform="matrix(-1 0 0 1 15 9)" fill="#FF7E7E"/>
      <circle cx="10" cy="10" r="9" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'annoyed'">
      <path d="M8 16L10 14L12 16" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.96446 7.5H7.99998" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="4" cy="9" r="1" fill="#FF7E7E"/>
      <path d="M18.0355 7.5L12 7.5" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle r="1" transform="matrix(-1 0 0 1 14 9)" fill="#FF7E7E"/>
      <circle cx="10" cy="10" r="9" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'blank'">
      <circle cx="5" cy="9" r="1" fill="#7ED8FF"/>
      <circle r="1" transform="matrix(-1 0 0 1 15 9)" fill="#7ED8FF"/>
      <circle cx="10" cy="10" r="9" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 14H13" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'blushing'">
      <ellipse cx="4.5" cy="11" rx="1.5" ry="1" fill="#FEA3C3"/>
      <ellipse cx="15.5" cy="11" rx="1.5" ry="1" fill="#FEA3C3"/>
      <circle cx="10" cy="10" r="9" stroke="#FEA3C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 8L4.58579 7.41421C5.36684 6.63316 6.63317 6.63317 7.41421 7.41421L8 8" stroke="#FEA3C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 8L12.5858 7.41421C13.3668 6.63316 14.6332 6.63317 15.4142 7.41421L16 8" stroke="#FEA3C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.5 14.3301C11.7399 14.769 10.8777 15 10 15C9.12232 15 8.2601 14.769 7.5 14.3301" stroke="#FEA3C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'cool'">
      <path d="M8 9V11C8 11 8 13 5 13C2 13 2 11 2 11V7.5H8V9ZM8 9H10H12M12 9V7.5H18V11C18 11 18 13 15 13C12 13 12 11 12 11V9Z" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="10" cy="10" r="9" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 16L8.58579 16.5858C9.36684 17.3668 10.6332 17.3668 11.4142 16.5858L12 16" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'happy'">
      <circle cx="10" cy="10" r="9" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15C8.67393 15 7.40216 14.4732 6.46448 13.5355" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 9L4.58579 8.41421C5.36684 7.63316 6.63317 7.63317 7.41421 8.41421L8 9" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 9L12.5858 8.41421C13.3668 7.63316 14.6332 7.63317 15.4142 8.41421L16 9" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'sad'">
      <circle cx="10" cy="10" r="9" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.5355 15C12.5979 14.0623 11.3261 13.5355 10 13.5355C8.67393 13.5355 7.40216 14.0623 6.46448 15" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 9L4.58579 9.58579C5.36684 10.3668 6.63317 10.3668 7.41421 9.58579L8 9" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 9L12.5858 9.58579C13.3668 10.3668 14.6332 10.3668 15.4142 9.58579L16 9" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'sick'">
      <path d="M1.96448 7.5H8" stroke="#97F077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.0355 7.5L12 7.5" stroke="#97F077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="10" cy="10" r="9" stroke="#97F077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 15L13 12M13 15L7 12" stroke="#97F077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'sleeping'">
      <circle cx="10" cy="14" r="1" fill="#A7EFFF"/>
      <circle cx="10" cy="10" r="9" stroke="#A7EFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 9L4.58579 9.58579C5.36684 10.3668 6.63317 10.3668 7.41421 9.58579L8 9" stroke="#A7EFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 9L12.5858 9.58579C13.3668 10.3668 14.6332 10.3668 15.4142 9.58579L16 9" stroke="#A7EFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'slightly-annoyed'">
      <path d="M1.96448 7.5H8" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="4" cy="9" r="1" fill="#FF7E7E"/>
      <path d="M18.0355 7.5L12 7.5" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle r="1" transform="matrix(-1 0 0 1 14 9)" fill="#FF7E7E"/>
      <circle cx="10" cy="10" r="9" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 14H13" stroke="#FF7E7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'smart'">
      <path d="M8.00003 8.99997V11C8.00003 11 8.00003 13 5.00003 13C2.00003 13 2.00003 11 2.00003 11V7.49997H8.00003V8.99997ZM8.00003 8.99997H10H12M12 8.99997V7.49997H18V11C18 11 18 13 15 13C12 13 12 11 12 11V8.99997Z" stroke="#B77EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="10" cy="10" r="9" stroke="#B77EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 16H13" stroke="#B77EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'smile'">
      <circle cx="6" cy="9" r="1" fill="#FCE300"/>
      <circle r="1" transform="matrix(-1 0 0 1 14 9)" fill="#FCE300"/>
      <circle cx="10" cy="10" r="9" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15C8.67393 15 7.40216 14.4732 6.46448 13.5355" stroke="#FCE300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'sobbing'">
      <path d="M1.96448 7.5H4.98224M4.98224 7.5H8M4.98224 7.5V17.5M18.0355 7.5H15.0178M15.0178 7.5H12M15.0178 7.5L15.0178 17.5M8 15L8.58579 14.4142C9.36684 13.6332 10.6332 13.6332 11.4142 14.4142L12 15M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <g v-if="emotion === 'unhappy'">
      <circle cx="6" cy="9" r="1" fill="#7ED8FF"/>
      <circle r="1" transform="matrix(-1 0 0 1 14 9)" fill="#7ED8FF"/>
      <circle cx="10" cy="10" r="9" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.5355 15C12.5979 14.0623 11.3261 13.5355 10 13.5355C8.67393 13.5355 7.40216 14.0623 6.46448 15" stroke="#7ED8FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    emotion: {
      type: String,
      default: 'smile',
    },
  },
};
</script>

<style lang="stylus" scoped>
.emotion
  display: inline-block
  margin: 0
  width: 20px
  height: 20px
</style>
